import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { VariantCatalog } from 'services/products'

const extra_columns = {
  name: {
    header: 'Variant Name',
    group: 'Variant Attributes',
  },
  product_name: {
    header: 'Product',
    group: 'Variant Attributes',
  },
  sku: {
    header: 'SKU',
    group: 'Variant Attributes',
  },
  format_pack_size: {
    header: 'Format / pack size',
    group: 'Variant Attributes',
  },
  gtin: {
    header: 'GTIN / UPC',
    group: 'Variant Attributes',
  },
  avg_price: {
    header: 'Avg Price per Unit',
    group: 'Variant Attributes',
  },
  brand_name: {
    header: 'Brand',
    group: 'Variant Attributes',
  },
  category: {
    header: 'Category',
    group: 'Syndigo Attributes',
  },
  source: {
    header: 'Source',
    group: 'Syndigo Attributes',
  },
  last_synced_at: {
    header: 'Last Synced At',
    group: 'Syndigo Attributes',
  },
}

export const VARIANT_COLUMNS = {
  ...extra_columns,
} satisfies Record<
  keyof VariantCatalog & keyof typeof extra_columns,
  DataTypeColumn
>
